export enum SiteWalkMediaViewTypeEnum {
    LIST = 'LIST',
    GRAPHICAL = 'GRAPHICAL',
}

export const SiteWalkMediaViewTypeLabels = {
    [SiteWalkMediaViewTypeEnum.LIST]: 'List',
    [SiteWalkMediaViewTypeEnum.GRAPHICAL]: 'Graphical',
};
